import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rsprogram',
  templateUrl: './rsprogram.component.html',
  styleUrls: ['./rsprogram.component.css']
})
export class RsprogramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
